export default "__VITE_ASSET__d5dc7d6b__"